import { getUserAgent } from "common/utils/window-location";

export const isMobileDevice = () =>
  /Android|webOS|iPhone|iPod|BlackBerry|Windows Phone|IEMobile|Opera Mini/i.test(
    getUserAgent(),
  );
